import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import * as api from 'dashboard/resources/store-sales-rank.api';
import storeSalesRankWidgetTemplate from './store-sales-rank-widget.html';

const mapStateToThis = ({ session, dictionary }) => {
  const { locale, retailer } = session;
  const terms = dictionary.terms[locale];

  return {
    retailer,
    userLocale: locale,
    terms,
  };
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class StoreSalesRankWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.loadDataAsync(() => api.fetchChainSalesRank(retailerId));
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class StoreSalesRankWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
    this.controller = StoreSalesRankWidgetController;
    this.template = storeSalesRankWidgetTemplate;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/store-sales-rank/store-sales-rank-widget-component.js